import { z } from 'zod';
import { BatchStatusSchema, SynthesisStageSchema } from './job';

export const SynthesisJobFileResponseSchema = z.object({
  fileIndex: z.number().int().nonnegative(),
  documentId: z.string().uuid(),
  status: z.string(),
  stage: SynthesisStageSchema.or(z.string()),
  progress: z.number().int().min(0).max(100),
  error: z.string().nullable(),
  result: z.unknown().nullable(),
  retryCount: z.number().int().nonnegative().default(0),
  startedAt: z.string().nullable(),
  completedAt: z.string().nullable(),
});

export const SynthesisJobStatusResponseSchema = z.object({
  success: z.boolean(),
  job: z.object({
    id: z.string().uuid(),
    status: BatchStatusSchema,
    stage: z.string().nullable(),
    progress: z.number().int().min(0).max(100),
    totalFiles: z.number().int().positive(),
    filesCompleted: z.number().int().nonnegative(),
    filesFailed: z.number().int().nonnegative(),
    currentBatchRegion: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string().nullable(),
    error: z.string().nullable(),                   // technical message
    errorCode: z.string().nullable().optional(),    // application error code (e.g. DOCUMENT_NOT_FOUND)
    errorMessage: z.string().nullable().optional(), // user-facing French message
  }),
  files: z.array(SynthesisJobFileResponseSchema),
});
export type SynthesisJobStatusResponse = z.infer<typeof SynthesisJobStatusResponseSchema>;
